import React from "react";

function LayoutFooter() {

    return (
        <footer className="footer-container">
            <span></span>
        </footer>
    );
}

export default LayoutFooter;
